import PhoneInput from "react-phone-input-2";
import { useSelector } from "react-redux";
import Tooltip from "../Tooltip/Tooltip";
const Phone = ({ value}) => {

  const { theme } = useSelector((state) => state.theme);

//   const { setFieldValue } = useFormikContext();

//   const handlePhoneChange = (phone) => {
//     // setFieldValue(name, phone);
//   };

  const containerStyles = {
    width: "100%",
    borderRadius: '0',
    // backgroundColor: theme === 'light' ? '':'#232223',
    // color: theme === "light" ? '#000' : '#fff',
  };
  
  const inputStyles = {
    height: "2.5rem",
    width: "65%",
    fontSize: "1.1rem",
    paddingLeft: "10px",
    border: "1px solid rgb(215, 215, 215)",
    width: "100%",
    borderRadius: '0',
    // backgroundColor: theme === 'light' ? '':'#232223',
    // color: theme === "light" ? '#000' : '#fff',
  };

  return (
    <PhoneInput
      country={"in"}
      value={value}
      disabled
    //   onChange={handlePhoneChange}
      countryCodeEditable={false}
      disableSearchIcon={true}
    //   inputProps={{
    //     // name: {name},
    //     required: true,
    //     autoFocus: false,
    //   }}
      containerStyle={containerStyles}
      inputStyle={inputStyles}
    />
  );
};

export default Phone;
